export default {
  resumeMetadata: {
    formLabels: {
      aboutMe: 'Расскажите о себе',
      level: 'Уровень образования',
      specialty: 'Специальность',
      company: 'Название компании',
      dateFrom: 'Начало работы',
      dateTo: 'Окончание работы',
      untilNow: 'По настоящее время',
      position: 'Должность',
      description: 'Описание рабочих обязанностей',
    },
    successMessages: {
      editProfile: 'Данные профиля успешно изменены',
      createEducation: 'Образование успешно добавлено',
      changeEducation: 'Образование успешно изменено',
      deleteEducation: 'Образование успешно удалено',
      deletePortfolio: 'Портфолио успешно удалено',
      changeWorkExp: 'Опыт работы успешно изменён',
      createWorkExp: 'Опыт работы успешно добавлен',
      deleteWorkExp: 'Опыт работы успешно удалён',
    },
    errorMessages: {
      editProfile: 'Не удалось изменить данные профиля',
      createEducation: 'Не удалось добавить образование',
      changeEducation: 'Не удалось изменить образование',
      deleteEducation: 'Не удалось удалить образование',
      deletePortfolio: 'Не удалось удалить портфолио',
      changeWorkExp: 'Не удалось изменить опыт работы',
      createWorkExp: 'Не удалось добавить опыт работы',
      deleteWorkExp: 'Не удалось удалить опыт работы',
    },
    deleteEducationTitle: 'Удалить образование?',
    addPortfolioButton: 'Добавить портфолио',
    deletePortfolioTitle: 'Удалить портфолио?',
    addWorkExpButton: 'Добавить опыт работы',
    deleteWorkExpTitle: 'Удалить опыт работы?',
    noWorkExp: 'Нет опыта работы',
    untilNow: 'по настоящее время',
  },
};
